import { connect } from 'react-redux'
import { createWidget } from 'pages/widgets/form-actions/create/actions'
import Form from 'pages/widgets/form'
import { getInitialReminderValues } from './initialValues'

const mapDispatch = {
  onSubmit: createWidget
}

const date = new Date().valueOf()

export default connect(
  () => ({ initialValues: getInitialReminderValues(date) }),
  mapDispatch
)(Form)



// WEBPACK FOOTER //
// ./src/pages/widgets/reminder/create/container/index.js